import { Component } from '@angular/core';

@Component({
  selector: 'app-zakat-icon',
  templateUrl: './zakat-icon.component.html',
})
export class ZakatIconComponent {

}
